import Vue from 'vue'

const el = document.querySelector('#notification')
if (el !== null) {
  const vm = new Vue({
    delimiters: ['${', '}'],
    data: {
      show: false,
      currentKey: null,
      notificationActive: true,
      className: 'notification-active'
    },
    methods: {
      hideNotification () {
        this.show = false
        localStorage.notificationActive = false
        this.className = 'hidden'
      },
      showNotification () {
        this.show = true
        localStorage.notificationActive = true
        this.className = 'notification-active'
      }
    },
    mounted () {
      this.currentKey = this.$el.getAttribute('data-key')
      if (localStorage?.notificationActive === 'false' && localStorage?.notificationKey === this.currentKey ) {
        this.show = false
        this.className = 'hidden'
      } else {
        this.show = true
        this.className = 'notification-active'
        localStorage.notificationActive = 'true'
        localStorage.notificationKey = this.currentKey
      }
    }
  })
  vm.$mount(el)
}
